export const Colors = {
  primary: '#ec008c',
  secondary: '#484B5D',
  warning: '#f5a623',
  success: '#64AD44',
  danger: '#D43F3D',
  titleText: '#929ADA',
  text: '#666B88',

  darkPrimary: '#3d444b',
  white: '#FFFFFF',
  whiteLight: 'rgba(255, 255, 255, 0.4)',

  buttonText: '#464763',

  // Background
  primaryBG: '#272731',
  secondaryBG: '#2E2E3A',
  heroBG: '#1D1F28',
  navBG: '#484B5E',
  cardBG: '#484B5E',
  cardFooter: '#2E2E3A',

  // border
  border: '#666B88',
  // Black
  black: '#000',
  superDark: '#34495e',
  blackOpacity54: 'rgba(0, 0, 0, 0.54)',

  // Gray
  grayLight: '#bfbfbf',
  grayMid: '#4a4a4a',
  grayDary: '#555555',
  bgGray: '#fcfcfd',
  borderGray: '#eaeaea',

  // BoxShadow
  boxShadowBlack24: 'rgba(0, 0, 0, 0.24)',
  boxShadowBlack32: 'rgba(164, 152, 135, 0.32)',
  boxShadowPrimary: '0 -3px 16px 0 rgba(0, 0, 0, 0.04)',

  madlabPrimary: '#ec008c',
};
